//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'popup-layer',
	// model: {
	// 	prop: "showPop",
	// 	event: "change"
	// },
	props: {
		showPop:{
			type:Boolean,
			default:false,
		},
		isWhite:{
			type:Boolean,
			default:true
		},
		direction: {
			type: String,
			default: 'top', // 方向  top，bottom，left，right 
		},
		autoClose: {
			type: Boolean,
			default: true,
		}
	},
	data() {
		return {
			ifshow: false, // 是否展示,
			translateValue: -100, // 位移距离
			site:-100,
			timer: null,
			iftoggle: false,

		};
	},
	computed: {
		_translate() {
			const transformObj = {
				'top': `transform:translateY(${-this.translateValue}%);`,
				'bottom': `transform:translateY(${this.translateValue}%);`,
				'left': `transform:translateX(${-this.translateValue}%);`,
				'right': `transform:translateX(${this.translateValue}%);`
			};
			return transformObj[this.direction]
		},
		_location() {
			const positionValue = {
				'top': `bottom:${this.site}%;width:100%;`,
				'bottom': `top:${this.site}%;width:100%;`,
				'left': `right:0px;top:0;height:100%;`,
				'right': `left:0px;top:0;height:100%;`
				
			};
			//`'background':${this.isWhite?'#FFF':''}`
			return positionValue[this.direction]+ this._translate+`background:${this.isWhite?'#FFF':''}`;
		}
	},
	mounted(){
		if(this.showPop){
			// console.log(222);
			this.show();
		}
	},
	watch:{
		showPop(value){
			if(value){
				this.show();
			}else{
				this.close();
			}
		}	
	},
	methods: {
		stopMove(event){
			return;
		},
		show(events) {
			this.ifshow = true;
			this.site=0;
			let _open = setTimeout(() => {
				this.translateValue = 0;
				_open = null;
			}, 0)
			let _toggle = setTimeout(() => {
				this.iftoggle = true;
				_toggle = null;
			}, 300);
		},
		close() {
			if (this.timer !== null || !this.iftoggle) {
				return;
			}
			this.translateValue = -100;				
			this.ifshow = false;
			
				this.timer = null;
				this.iftoggle = false;
				
				this.$emit('closeCallBack', null);
				this.$emit('change',false)
			// this.timer = setTimeout(() => {
			// }, 300);				
		},
		ableClose() {
			if (this.autoClose) {
				this.close();
			}
		},
		stopEvent(event) {},
		doSome(){
		}

	}
}
